import { render, staticRenderFns } from "./BookmarkInCard.vue?vue&type=template&id=e16ed08c&"
import script from "./BookmarkInCard.vue?vue&type=script&lang=ts&"
export * from "./BookmarkInCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports